'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../../../../../../../styleInject.js');

var css_248z = ".ActionOption-module_action__tSAGR{align-items:center;grid-template-columns:1rem 1fr 1rem}";
var styles = {"action":"ActionOption-module_action__tSAGR"};
styleInject["default"](css_248z, '87177128-89bd-4096-96a2-4c98347d17c6');

exports["default"] = styles;
